import { useState, useEffect } from 'react'

import { getProfileLoyalty } from 'lmcv/services/profile'

export function useProfileLoyalty () {
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  useEffect(() => {
    getProfileLoyalty()
      .then(data => {
        setData(data)
        setLoading(false)
      })
      .catch(err => {
        setError(err.response)
        setLoading(false)
      })
  }, [])

  return [data, loading, error]
}
